// Steps for homepage
const onboardingSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: "🙋<br>Let' start",
        description: "<b>On this page you can find an overview of all new employees and their pre-boarding, onboarding & employee development. </b><br><br> To add a new employees, just click on them in the 'Hiring' tab and set 'To Hire' round. You can also add it with the plus sign at the top right corner 👌",
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: ".filters-wrapper",
    popover: {
        title: '🥳<br>Timeline offer you an overview of the whole onboarding process',
        description: 'You can scroll through the onboarding phases and <b>see the employees who are currently going through this phase.</b> In the red circle <div class="badge badge-timeline-red"><span>3</span></div> you can see their total number.',
        position: 'bottom-right',
        showButtons: true,
    },
},
{
    element: ".filters-loop-wrapper",
    popover: {
        title: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 19"></polyline></svg>',
        description: '<b>Employees move through the onboarding timeline automatically.</b> Just select their start date.<br><br><i>Unlike the "Hiring" section, where you can choose the candidates to be sent to the next round. </i>',
        position: 'bottom-right',
        showButtons: true,
    },


},
{
    element: ".table",
    popover: {
        title: '🧑<br>Employee overview',
        description: 'You can add tags, experience, ★ ratings and your own notes to each employee.',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: ".filters-bar",
    popover: {
        title: ' ',
        description: '<b>In the default state you can see all employees regardless of the job. </b>For a close inspection, you may filter the results by job title. In this way you can see the progress of onboarding for different groups of employees. 🙂',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../onboarding?profile=12" target="_blank" title="Více"><img src="/images/guide-onboarding-1.png"></a>',
        description: '<b>You can track and edit start date and to-do lists for HR department and employees</b> by clicking on the icon <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>. ',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        title: 'Awesome!',
        description: 'See the progress of your onboarding to-do list <br>(1 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Yes, carry on',
        nextBtnText: 'Understood',        // Next button text for this step
        prevBtnText: 'Back',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding/checklist#guide");

    }
},
]



export default onboardingSteps
